import { BaseRouteConfig } from './BaseRoute';

export class LockedPath extends BaseRouteConfig {
  public readonly Index = '/locked';
}
